import React from 'react';
import {useRouter} from 'next/router';

const CORE_VALUES_CONTENT = {
    title: 'Giá trị cốt lõi',
    title_en: 'Core Values',
    array_values: [
        {
            num_index: '1',
            title_value: 'Tận tâm',
            title_value_en: 'Dedication',
            description: 'Người bệnh là trung tâm của mọi hoạt động.',
            description_en: 'Patients are at the center of all our activities.',
        },
        {
            num_index: '2',
            title_value: 'Chuyên nghiệp',
            title_value_en: 'Professionalism',
            description: 'Tuân thủ các chuẩn mực chuyên môn và đạo đức nghề nghiệp.',
            description_en: 'Adherence to professional standards and ethical conduct.',
        },
        {
            num_index: '3',
            title_value: 'Đổi mới',
            title_value_en: 'Innovation',
            description: 'Không ngừng ứng dụng khoa học công nghệ và phương pháp quản trị tiên tiến.',
            description_en: 'Continuously applying science, technology, and advanced management methods.',
        },
        {
            num_index: '4',
            title_value: 'Hợp tác',
            title_value_en: 'Collaboration',
            description: 'Phát triển trên nền tảng đoàn kết và kết nối.',
            description_en: 'Development based on solidarity and connectivity.',
        },
    ],
};

export default function AboutUsValues({aboutus}) {
    const {locale} = useRouter();
    const values = {
        ...aboutus?.WEB_ABOUT_COREVALUES?.value,
        ...CORE_VALUES_CONTENT,
    };
    const items = values.array_values;

    const staticIcons = [
        '/bw_image/ic_dedication.png',
        '/bw_image/ic_innovation.png',
        '/bw_image/ic_efficiency.png',
        '/bw_image/ic_collaboration.svg',
    ];

    return (
        <div className="about-us__values">
            <h2 className="about-us-values__title">{locale === 'en' ? values.title_en : values.title}</h2>
            <div className="about-us__values-grid">
                {items.map((v, index) => (
                    <div key={v.num_index || index} className="value-card">
                        <img
                            src={staticIcons[index]}
                            alt={locale === 'en' ? v.title_value_en : v.title_value}
                            className="value-card__icon"
                        />
                        <span className="value-card__number">{v.num_index?.padStart(2, '0')}</span>
                        <h3>{locale === 'en' ? v.title_value_en : v.title_value}</h3>
                        <p>{locale === 'en' ? v.description_en : v.description}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}
